import axios from 'axios';
import { useOperatorGateStore } from '../store/operatorGateStore';

const API_URL = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: `${API_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const impRole = localStorage.getItem('impersonate_role_id');
  if (impRole) {
    config.headers['X-Impersonate-Role'] = impRole;
  }
  return config;
});

api.interceptors.response.use(
  (response) => {
    const ct = response.headers['content-type'] || '';
    if (typeof response.data === 'string' && ct.includes('text/html')) {
      return Promise.reject(new Error('API returned HTML instead of JSON'));
    }
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // Рабочее место без активного оператора: не refresh и не /login,
    // а экран выбора оператора (спека 2026-09-25)
    if (
      error.response?.status === 401 &&
      error.response?.data?.detail === 'operator_required'
    ) {
      useOperatorGateStore.getState().notifyRequired();
      return Promise.reject(error);
    }

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const refreshToken = localStorage.getItem('refresh_token');
      if (refreshToken) {
        try {
          const res = await axios.post(`${API_URL}/api/auth/refresh`, {
            refresh_token: refreshToken,
          });
          const { access_token, refresh_token } = res.data;
          localStorage.setItem('access_token', access_token);
          localStorage.setItem('refresh_token', refresh_token);
          originalRequest.headers.Authorization = `Bearer ${access_token}`;
          return api(originalRequest);
        } catch {
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          window.location.href = '/login';
        }
      } else {
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);

export default api;
